import { MapRenderer } from './map-renderer.js?v=20260728-claude-camera-1';
import { versioned } from './tile-utils.js';

const GAME = '/game';
const mapCache = new Map();
let sharedAssetsPromise = null;
const ROUTE_BACKGROUND_LAYERS = Object.freeze(['onbottom', 'bottom', 'top', 'borders']);
const ROUTE_OCCLUSION_LAYERS = Object.freeze(['toppers']);

// Mesmo carimbo de build da cidade: a rota consome o mesmo atlas, e manifesto
// novo com página velha desenharia o sprite errado em cada tile.
async function fetchJson(path) {
  const response = await fetch(versioned(path));
  if (!response.ok) throw new Error(`Falha ao carregar ${path}`);
  return response.json();
}

export function loadRouteMapDoc(mapKey) {
  if (!/^[a-z0-9-]+-r[0-4]$/.test(mapKey)) {
    return Promise.reject(new Error(`Chave de rota inválida: ${mapKey}`));
  }
  if (!mapCache.has(mapKey)) {
    mapCache.set(mapKey, fetchJson(`${GAME}/maps/route-${mapKey}.json`));
  }
  return mapCache.get(mapKey);
}

function loadSharedAssets() {
  if (!sharedAssetsPromise) {
    sharedAssetsPromise = Promise.all([
      fetchJson(`${GAME}/draworder.json`),
      fetchJson(`${GAME}/asset-packs/version.json`),
    ]).then(async ([drawOrder, version]) => ({
      drawOrder,
      manifest: await fetchJson(`${GAME}/asset-packs/${version.items}`),
    }));
  }
  return sharedAssetsPromise;
}

export async function initRoutePixi(host, overlayHost, mapKey) {
  // Compatibilidade com o bootstrap legado, que ainda chamava (host, mapKey).
  if (mapKey === undefined) {
    mapKey = overlayHost;
    overlayHost = null;
  }
  const mount = document.createElement('div');
  mount.className = 'route-pixi-mount';
  host.replaceChildren(mount);
  const topperMount = overlayHost ? document.createElement('div') : null;
  if (topperMount) {
    topperMount.className = 'route-pixi-overlay-mount';
    overlayHost.replaceChildren(topperMount);
  }
  const [mapDoc, { drawOrder, manifest }] = await Promise.all([
    loadRouteMapDoc(mapKey),
    loadSharedAssets(),
  ]);
  const renderer = new MapRenderer(mount);
  const topperRenderer = topperMount ? new MapRenderer(topperMount) : null;
  const initResults = await Promise.allSettled([
    renderer.init({
      mapDoc,
      manifest,
      drawOrder,
      viewport: true,
      canvasClass: 'route-pixi-canvas',
      renderLayers: ROUTE_BACKGROUND_LAYERS,
    }),
    topperRenderer?.init({
      mapDoc,
      manifest,
      drawOrder,
      viewport: true,
      canvasClass: 'route-pixi-overlay-canvas',
      renderLayers: ROUTE_OCCLUSION_LAYERS,
      backgroundAlpha: 0,
    }),
  ]);
  const failedInit = initResults.find((result) => result.status === 'rejected');
  if (failedInit) {
    renderer.destroy();
    topperRenderer?.destroy();
    throw failedInit.reason;
  }
  return { renderer, topperRenderer, mapDoc };
}
